<template>
<ValidationObserver ref="observer">
  <form ref="add_business_unit_form" @submit.prevent="addPool">

    <md-card>
      <md-card-content>
        <div class="md-layout">
          <div class="md-layout-item md-small-size-100">
              <validation-provider rules="harus" v-slot="{ errors }">
                <md-field class="md-invalid">
                  <label>Warehouse Name</label>
                  <md-input v-model="warehouse_name" required/>
                  <validation-error :errors="apiValidationErrors.warehouse_name" />
                  <span class="md-error">{{ errors[0] }}</span>
                </md-field>
              </validation-provider>
            </div>
        </div>

        <div class="md-layout">
          <div class="md-layout-item md-small-size-100">
              <validation-provider rules="harus" v-slot="{ errors }">
                <md-field class="md-invalid">
                  <label>Eshed</label>
                  <md-select v-model="warehouse_pool_id" required>
                    <md-option v-for="option in options_pool_list" :key="option.value" :value="option.id">
                      {{ option.pool_name }}
                    </md-option>
                  </md-select>

                  <validation-error :errors="apiValidationErrors.warehouse_pool_id" />
                  <span class="md-error">{{ errors[0] }}</span>
                </md-field>
              </validation-provider>
            </div>
        </div>


        <div class="md-layout">
          <div class="md-layout-item md-small-size-100">
              <validation-provider rules="harus" v-slot="{ errors }">
                <md-field class="md-invalid">
                  <label>Warehouse Head</label>
                  <md-select v-model="warehouse_head_id" required>
                    <md-option v-for="option in options_user_list" :key="option.value" :value="option.id">
                      {{ option.name }}
                    </md-option>
                  </md-select>
                  <validation-error
                    :errors="apiValidationErrors.warehouse_head_id"
                  />
                  <span class="md-error">{{ errors[0] }}</span>
                </md-field>
              </validation-provider>
            </div>
        </div>

        <div class="md-layout">
          <div class="md-layout-item md-small-size-100">
              <validation-provider v-slot="{ errors }">
                  <md-checkbox v-model="warehouse_workshop">Warehouse Workshop</md-checkbox>
                  <validation-error
                    :errors="apiValidationErrors.warehouse_workshop"
                  />
                  <span class="md-error">{{ errors[0] }}</span>
              </validation-provider>
            </div>
        </div>
<!-- 
        <div class="md-layout">
          <div class="md-layout-item md-small-size-100">
              <validation-provider rules="harus" v-slot="{ errors }">
                <md-field class="md-invalid">
                  <label>Workshop Head</label>
                  <md-select v-model="pool_workshop_head_id" required>
                    <md-option v-for="option in options_workshop_head_list" :key="option.value" :value="option.id">
                      {{ option.name }}
                    </md-option>
                  </md-select>
                  <validation-error
                    :errors="apiValidationErrors.pool_workshop_head_id"
                  />
                  <span class="md-error">{{ errors[0] }}</span>
                </md-field>
              </validation-provider>
            </div>
        </div> -->
        
      </md-card-content>

      <md-card-actions>
        <md-button class="md-info md-dense" @click="addConfirmation">
          Submit
        </md-button>
      </md-card-actions>
    </md-card>
  </form>
</ValidationObserver>
  
</template>

<script>
import {ValidationError} from "@/components";
import formMixin from "@/mixins/form-mixin";
import { extend , validate, localize , ValidationObserver } from 'vee-validate';
import { required } from 'vee-validate/dist/rules';
import Vue from 'vue'
import VueSweetalert2 from 'vue-sweetalert2';
import Swal from 'sweetalert2';

Vue.use(VueSweetalert2);

// mengirim pesan error ketika required field tidak diisi
extend('harus', {
  ...required,
  message: 'Field is required'
});
  
  export default {
     name: "add-pool",

    props: {
      data: Object
    },

    components: {ValidationError, ValidationObserver},

    mixins: [formMixin],

    data: () => ({
      warehouse_name: null,
      warehouse_pool_id: null,
      warehouse_head_id: null,
      warehouse_workshop: null,
      options_user_list: null,
      options_pool_list: null
    }),

    created() {
      this.getPool();
      this.getWarehouseHead();
    },

  
    methods: {

      async getPool(){
        await this.$store.dispatch("workshop_pool/list")
        this.options_pool_list = await this.$store.getters["workshop_pool/list"]
      },

      async getWarehouseHead(){
        await this.$store.dispatch("users/list_workshop_head")
        this.options_user_list = await this.$store.getters["users/list"]
      },


     // validasi menggunakan sweetalert  sebelum menambah data
    async addConfirmation() {
      const isValid = await this.$refs.observer.validate();
      if (!isValid) {
        return
      }
    Swal.fire({
        title: 'Are you sure?',
        text: 'The data will be saved!',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes, Save it!',
        cancelButtonText: 'No, cancel!',
        buttonsStyling: true
        }).then((result) => {
          if (result.value){
            this.addWarehouse()
          }
        });
    },


    // fungsi add data
      async addWarehouse() {

       
        const data = {
          type: "workshop_warehouses",
          // client_no: this.client_no,
          warehouse_name: this.warehouse_name,
          warehouse_head_id: this.warehouse_head_id,
          warehouse_pool_id: this.warehouse_pool_id,
          warehouse_workshop: this.warehouse_workshop
        }


        try {
        await this.$store.dispatch("workshop_warehouse/add", data);
        await this.$store.dispatch(
          "alerts/success",
          "Successfully registered."
        );
        this.$parent.$parent.modalCloseAdd();
      } catch (e) {
        // await this.$store.dispatch(
        //   "alerts/error",
        //   "Oops, something went wrong"
        // );
        console.log(e);
        this.setApiValidation(e.response.data.errors);
      }

      }
    }
  };
</script>
